export default {
  // 路由国际化
  route: {
    dashboard: "Dashboard",
    document: "Document",
    system: "System",
    user: "Users",
    role: "Roles",
    menu: "Menus",
    dict: "Dictionaries",
    dept: "Departments",
    reporting: "Reports",
    weekly: "Weekly",
    dailySpecial: "Daily Special",
    daily: "Daily",
    workReport: "Work",
    meeting: "Meeting",
    reportMessages: "Report Messages",
    notice: "Notices",
    finance: "Finance",
    reserves: "Reserves",
    borrow: "Borrow",
    reimbursement: "Reimbursement",
    documents: "Important Documents",
    expenses: "Expenses",
    contract: "Contract",
    statements: "Statements",
    invoice: "Invoice",
    personnel: "Personnel",
    dimission: "Resignations",
    regularization: "Regularization",
    performance: "Performance",
    emp: "Employees",
    positions: "Positions",
    customer: "Customer",
    customerLists: "Customer List",
    disuseCustomers: "Inactive Customers",
    followUpRecords: "Follow-up Records",
    wflow: "Workflows",
    design: "Design Workflows",
    approvalList: "Available Workflows",
    myApplication: "My Workflows",
    carbonCopy: "Carbon Copies",
    myPending: "My Pending Tasks",
    myProcessed: "Processed by Me",
    admin: "Create Form",
    administrative: "Administrative",
    documentation: "Documentation",
    development: "Development",
    workorder: "Work Orders",
    ticketAll: "All Tickets",
    myCreate: "Created By Me",
    ticketlist: "Ticket List",
    createticket: "Create Ticket",
    processingticket: "Ticket Details",
    netdisc: "Enterprise Drive",
    settings: "Settings",
    myFiles: "My Files",
    profile: "Profile",
    findAllNotice: "All Notices",
  },
  404: {
    home: "Return to home",
  },
  // 登录页面国际化
  login: {
    username: "Username",
    password: "Password",
    login: "Login",
    captchaCode: "Verify Code",
    capsLock: "Caps Lock is On",
    userRegistration: "Register an Account",
    forgotPassword: "Forgot Password",
    confirmPassword: "Confirm Password",
    enterEmail: "Enter your email address",
    sendEmailCode: "Send Email Verification Code",
    register: "Register",
    userLogin: "User Login",
    nextStep: "Next Step",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    second: "Second",
    enterUsername: "Please enter your username",
    enterPassword: "Please enter your password",
    passwordTooShort: "Password must be at least 6 characters",
    enterVerificationCode: "Please enter the verification code",
    enterYourEmail: "Please enter your email",
    enterValidEmail: "Please enter a valid email address",
    repeatPasswordRequired: "Please confirm your password",
    passwordsDoNotMatch: "Passwords do not match!",
    emailSent: "Email has been sent, please check your inbox",
    registrationSuccess: "Registration Successful",
    usernameExists: "This username already exists",
    passwordResetSuccess: "Password reset successful",
  },
  dashboard: {
    initiateNotification: "Create a Ticket",
    processWorkflow: "Process Workflow",
    announcementNotification: "Announcement Notifications",
    more: "More",
    noAnnouncements: "No Announcements",
    dailyReport: "Daily Report",
    dailyReportOnly: "Daily Special Report",
    weeklyReport: "Weekly Report",
    workReport: "Work Report",
    expenseIncome: "Expense & Income",
    meetingSummary: "Meeting Summary",
    morningPoem:
      "Rise early, dress up, and step out into the courtyard, the breeze through the window brings quiet joy🌅!",
    goodMorning: "Good morning, {name}!",
    goodAfternoon: "Good afternoon, {name}!",
    goodEvening: "Good evening, {name}!",
    goodNightPoem:
      "I secretly borrowed a handful of stardust from the Milky Way, just to sprinkle into your dreams—good night🌛!",
    clickToDownload: "Click to Download",
    unfinishedNotification: "Pending Notifications",
    urgentReminder: "Urgent Reminders",
    completed: "Completed",
    annual: "Annual Statistics",
    income: "Income",
    expense: "Expense",
    monthlyStatistics: "Monthly Statistics",
    monthName: "Month",
    paymentCategoryStatistics: "Payment Category Statistics",
    selectTimeRange: "Select Time Range",
    firstHalfOfYear: "First Half of {currentYear}",
    secondHalfOfYear: "Second Half of {currentYear}",
    wechat: "WeChat",
    corporateAccount: "Corp",
    creditCard: "Credit Card",
    alipay: "Alipay",
    announcementTitle: "Title",
    enterAnnouncementTitle: "Enter announcement title",
    announcementType: "Type",
    selectAnnouncementType: "Select type",
    publisher: "Publisher",
    publishTime: "Time",
    status: "Status",
    enabled: "Active",
    disabled: "Inactive",
    assignedDepartment: "Department",
    selectDepartment: "Select department",
    content: "Content",
    enterContent: "Enter content",
    announcementDetails: "Details",
    quarterlyStatistics: "Quarterly Statistics",
    firstQuarter: "First Quarter",
    secondQuarter: "Second Quarter",
    thirdQuarter: "Third Quarter",
    fourthQuarter: "Fourth Quarter",
  },
  profile: {
    personalInfo: "Profile Info",
    username: "Username",
    phoneNumber: "Phone Number",
    email: "Email",
    department: "Team",
    role: "Role",
    createdAt: "Joined",
    basicProfile: "Basic Info",
    changePassword: "Change Password",
    oldPassword: "Current Password",
    enterOldPassword: "Enter your current password",
    newPassword: "New Password",
    enterNewPassword: "Enter your new password",
    confirmPassword: "Confirm Password",
    enterConfirmPassword: "Re-enter your new password",
    save: "Save",
    close: "Close",
    passwordMismatch: "Passwords do not match",
    newSameAsOld: "New password must be different from the current password",
    oldPasswordRequired: "Current password is required",
    newPasswordRequired: "New password is required",
    invalidCharacters:
      "Cannot contain the following characters: < > \\\" ' \\\\ |",
    passwordLengthLimit: "Must be between 6 and 20 characters",
    confirmPasswordRequired: "Please confirm your new password",
    passwordChangeSuccess:
      "Password updated successfully. Please log in again.",
    nickname: "Nickname",
    gender: "Gender",
    male: "Male",
    female: "Female",
    nicknameRequired: "Nickname is required",
    emailRequired: "Email is required",
    invalidEmail: "Please enter a valid email address",
    phoneRequired: "Phone number is required",
    invalidPhone: "Please enter a valid phone number",
    updateSuccess: "Profile updated successfully",
    updateFailed: "Failed to update profile: {0}",
    uploadAvatar: "Upload Avatar",
    choose: "Choose",
    submit: "Submit",
    invalidFileFormat: "Invalid file format. Please upload an image.",
    fileTooLarge: "File is too large. Please upload an image smaller than 5MB.",
    avatarUpdateSuccess: "Avatar updated successfully",
    avatarUpdateFailed: "Failed to update avatar",
    retryAvatarUpdate: "Avatar update failed. Please try again.",
    cropFailed: "Failed to get cropped image",
  },
  // 导航栏国际化
  navbar: {
    dashboard: "Dashboard",
    logout: "Logout",
    document: "Documents",
    gitee: "Gitee",
    personalCenter: "Profile",
  },
  sizeSelect: {
    tooltip: "Layout Size",
    default: "Default",
    large: "Large",
    small: "Small",
    message: {
      success: "Layout size updated!",
    },
  },
  langSelect: {
    message: {
      success: "Language switched!",
    },
  },
  settings: {
    project: "Project Settings",
    theme: "Theme",
    interface: "Interface",
    navigation: "Navigation",
    themeColor: "Theme Color",
    tagsView: "View Tags",
    fixedHeader: "Fixed Header",
    sidebarLogo: "Sidebar Logo",
    watermark: "Watermark",
    leftMode: "Sidebar Layout",
    topMode: "Topbar Layout",
    mixedMode: "Mixed Layout",
  },
  positions: {
    message: {
      successDelete: "Position(s) deleted successfully",
      editSuccess: "Job edited successfully",
      addSuccess: "Position added successfully",
    },
  },
  dept: {
    keyword: "Keyword",
    departmentName: "Department Name",
    departmentStatus: "Department Status",
    all: "All",
    active: "Active",
    inactive: "Inactive",
    reset: "Reset",
    search: "Search",
    add: "Add",
    delete: "Delete",
    positionNum: "Position Number",
    status: "Status",
    displayOrder: "Sort",
    sort: "Sort",
    operate: "Actions",
    edit: "Edit",
    editJobInfo: "Edit Job Information",
    newPosition: "Add Position",
    enterJobTitlePlaceholder: "Please enter a job title",
    superiorDepartment: "Superior Department",
    selectSuperiorDepartment: "Select Superior Department",
    pleaseEnterDepartmentName: "Please enter the department name",
    showSort: "Sort",
    confirm: "Confirm",
    cancel: "Cancel",
    message: {
      jobTitle: {
        required: "Job title cannot be empty",
      },
      dept: {
        required: "Department cannot be empty",
      },
      parentId: {
        required: "Parent department cannot be empty",
      },
      name: {
        required: "Department name cannot be empty",
      },
      sort: {
        required: "Sort cannot be empty",
      },
      remove: {
        check: "Please check the items to be deleted",
        warn: "Warning",
        confirm: "Confirm deletion of selected position(s)?",
        successDelete: "Department(s) deleted successfully",
      },
    },
    topDept: "Top-level Department",
    modifyDept: "Edit Department Information",
    newDept: "Add Department",
    successModify: "Edited successfully",
    addSuccess: "Added successfully",
    Confirm_selected_data_items: "Confirm deletion of selected department(s)",
    departmentHead: "Department Head",
    selectDepartmentHead: "Please select a department head",
    departmentHeadRequired: "Department head cannot be empty",
  },
  role: {
    keyword: "Keyword",
    roleName: "Role Name",
    reset: "Reset",
    search: "Search",
    new: "Add",
    delete: "Delete",
    roleCoding: "Role ID",
    normal: "Enabled",
    disable: "Disabled",
    status: "Status",
    sort: "Sort",
    operate: "Actions",
    assignPermissions: "Assign Permissions",
    edit: "Edit",
    dataPermission: "Data Permissions",
    allData: "All Data",
    departmentData: "Department & Sub-department Data",
    Data_this_department: "This Department's Data",
    Personal_data: "Personal Data",
    confirm: "Confirm",
    cancel: "Cancel",
    modifyRole: "Edit Role",
    newRole: "Add Role",
    deactivate: "Disabled",
    message: {
      name: {
        placeholder: "Please enter a role name",
        required: "Role name cannot be empty",
      },
      code: {
        placeholder: "Please enter a role ID",
        required: "Role ID cannot be empty",
      },
      dataScope: {
        placeholder: "Please select data permissions",
        required: "Data permissions cannot be empty",
      },
      status: {
        required: "Please select a status",
      },
      remove: {
        check: "Please check the items to be deleted",
        warn: "Warning",
        successDelete: "Role(s) deleted successfully",
      },
    },
    successModify: "Role edited successfully",
    addSuccessfully: "Role added successfully",
    Confirm_selected_data_items: "Confirm deletion of selected role(s)",
    Permissions_assigned_successfully: "Permissions assigned successfully",
  },
  NavbarRight: {
    Are_you_sure_system: "Are you sure you want to log out and exit",
    confirm: "Confirm",
    cancel: "Cancel",
    prompt: "Confirm Logout",
  },
  user: {
    departmentName: "Department Name",
    keyword: "Keyword",
    keywordValue: "Username / Nickname / Phone",
    status: "Status",
    all: "All",
    creationTime: "Created At",
    startTime: "Start Time",
    endTime: "End Time",
    enable: "Enabled",
    disable: "Disabled",
    search: "Search",
    reset: "Reset",
    new: "Add",
    delete: "Delete",
    import: "Import",
    downloadTemplate: "Download Template",
    importData: "Import Data",
    export: "Export",
    edit: "Edit",
    resetPassword: "Reset Password",
    operate: "Actions",
    tel: "Phone",
    jobTitle: "Job Title",
    department: "Department",
    id: "ID",
    username: "Username",
    nickname: "Nickname",
    gender: "Gender",
    message: {
      username: {
        required: "Please enter a username",
      },
      nickname: {
        required: "Please enter a nickname",
      },
      department: {
        required: "Please select a department",
      },
      pleaseSelect: {
        required: "Select",
      },
      tel: {
        required: "Please enter a phone number",
      },
      email: {
        required: "Please enter an email address",
      },
      rules: {
        username: "Username cannot be empty",
        nickname: "Nickname cannot be empty",
        deptId: "Department cannot be empty",
        roleIds: "Role must be selected",
        email: "Please enter a valid email address",
        tel: "Please enter a valid phone number",
      },
      password: {
        notallow: "You can only change your own password!",
        user: "Please enter the user「",
        newPassword: "」's new password",
        error: "Password length cannot be less than 6 characters",
        inputNewPassword: "Please enter a new password",
        resetSuccessful: "Password reset successful. The new password is: ",
      },
      userForm: {
        modifyUser: "Edit User Information",
        addUser: "Add User",
        importUsers: "Import Users",
        modification: "User information edited successfully",
        addition: "User added successfully",
      },
      userImport: {
        department: "Please select a department",
        excel: "The uploaded Excel file cannot be empty",
        import: "User import successful",
      },
      remove: {
        check: "Please check the items to be deleted",
        deletion: "Confirm deletion of selected user(s)?",
        warn: "Warning",
        successDelete: "User(s) deleted successfully",
      },
    },
    role: "Role",
    email: "Email",
    normal: "Active",
    execl: "Excel",
    dragFilesHere: "Drag files here, or",
    upload: "Click to upload",
    confirm: "Confirm",
    cancel: "Cancel",
  },
  menu: {
    keyword: "Keyword",
    search: "Search",
    reset: "Reset",
    new: "Add",
    status: "Status",
    sort: "Sort",
    operate: "Actions",
    edit: "Edit",
    delete: "Delete",
    confirm: "Confirm",
    cancel: "Cancel",
    successModify: "Menu edited successfully",
    addSuccessfully: "Menu added successfully",
    message: {
      remove: {
        check: "Please check the items to be deleted",
        warn: "Warning",
        successDelete: "Menu deleted successfully",
      },
    },
    Confirm_selected_data_items: "Confirm deletion of the selected item?",
    deletion: "Deletion cancelled",
    menuTitle: "Menu Title",
    type: "Type",
    directory: "Directory",
    menu: "Menu",
    button: "Button",
    link: "External Link",
    show: "Visible",
    hide: "Hidden",
    parentMenu: "Parent Menu",
    selectParentMenu: "Select Parent Menu",
    enterMenuName: "Please enter a menu title",
    menuType: "Navigation Type",
    linkAddress: "External Link",
    linkURL: "Please enter a full external link (e.g. https://example.com)",
    routePath: "Route Path",
    componentPath: "Component Path",
    permissionIdentifier: "Permission Identifier",
    yes: "Yes",
    no: "No",
    cacheEnabled: "Cache Enabled",
    displayRoot: "Always Show",
    yesRoot:
      "Yes: If root directory has only one sub-route, display it directly",
    noRoot:
      "No: If root directory has only one sub-route, only display sub-route",
    pagePath: "Page Path",
    displayStatus: "Display Status",
    icon: "Icon",
    redirectRoute: "Redirect Route",
    top_levelMenu: "Top-level Menu",
    editMenu: "Edit Menu",
    addMenu: "Add Menu",
    rules: {
      parentId: "Please Select Top-level Menu",
      name: "Menu title cannot be empty",
      type: "Menu type cannot be empty",
      path: "Route path cannot be empty",
      link: "External link cannot be empty",
      component: "Page path cannot be empty",
    },
    clickToSelectIcon: "Click to select an icon",
    searchIcon: "Search icon",
  },
  dict: {
    keyword: "Keyword",
    search: "Search",
    reset: "Reset",
    new: "Add",
    delete: "Delete",
    dictionaryTypeNameOrCode: "Dictionary Type / Type Code",
    dictionaryTypeName: "Dictionary Type",
    dictionaryTypeCode: "Type Code",
    status: "Status",
    remarks: "Description",
    actions: "Actions",
    enabled: "Active",
    disabled: "Inactive",
    dictionaryData: "Dictionary Data",
    edit: "Edit",
    editDictionaryType: "Edit Dictionary Type",
    addDictionaryType: "Add Dictionary Type",
    dictionaryName: "Dictionary Entry",
    dictionaryCode: "Type Code",
    enterDictionaryName: "Please enter a dictionary name",
    enterDictionaryCode: "Please enter a dictionary code",
    normal: "Active",
    inactive: "Inactive",
    dictionaryTypeRemarks: "Enter a description (optional)",
    confirm: "Confirm",
    cancel: "Cancel",
    enterDictionaryTypeName: "Dictionary type cannot be empty",
    enterDictionaryTypeCode: "Type code cannot be empty",
    editSuccess: "Edit successful",
    addSuccess: "Addition successful",
    selectItemsToDelete: "Please select items to delete",
    confirmDeleteSelected: "Confirm deletion of selected dictionary type(s)?",
    warning: "Warning",
    deleteSuccess: "Deletion successful",
    dictionaryValue: "Entry Value",
    sortOrder: "Sort",
    tagType: "Tag Type",
    clear: "Clear",
    enterDictionaryValue: "Entry value cannot be empty",
    editDictionary: "Edit Entry",
    addDictionary: "Add Dictionary Entry",
  },
  design: {
    createForm: "Create Form",
    createGroup: "Create Group",
    dragSortForms:
      "Drag and drop to reorder forms within groups (click and hold anywhere on a form) ",
    dragSortGroups: " Groups can also be reordered using this icon",
    edit: "Edit",
    delete: "Delete",
    updatedAt: "Updated on: ",
    editItem: "Edit",
    deactivate: "Deactivate",
    activate: "Activate",
    submit: "Confirm",
    move: "Move",
    addGroup: "Add Group",
    addGroupSuccess: "New group added successfully",
    inputGroupNameToAdd: "Please enter a new group name",
    emptyGroupName: "Group name cannot be empty",
    cancel: "Cancel",
    confirm: "Confirm",
    editGroup: "Edit Group",
    groupEditSuccess: "Group edited successfully",
    inputNewGroupName: "Please enter a new group name",
    inputGroupName: "Enter a new group name",
    confirmEnable: "Activate Form",
    confirmEnableForm: "Are you sure you want to activate this form?",
    confirmDisable: "Deactivate Form",
    confirmDisableForm: "Are you sure you want to deactivate this form?",
    enableSuccess: "Form activated successfully",
    disableSuccess: "Form deactivated successfully",
    selectGroup: "Please select a group",
    moveToGroupSuccess: "Moved form to new group successfully",
    deleteSuccess: "Form deleted successfully",
    deleteGroupSuccess: "Group deleted successfully",
    sortSuccess: "Reordered successfully",
    deleteForm: "Delete Form",
    confirmDeleteForm: "Are you sure you want to delete this form?",
    deleteGroup: "Delete Group",
    confirmDeleteGroup: "Are you sure you want to delete this group?",
  },
  notice: {
    keyword: "Keyword",
    announcementTitle: "Title",
    enterAnnouncementTitle: "Enter a title",
    announcementType: "Type",
    search: "Search",
    reset: "Reset",
    add: "Add",
    delete: "Delete",
    index: "No.",
    assignedDepartment: "Department",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    createdBy: "Created By",
    createdAt: "Created At",
    actions: "Actions",
    edit: "Edit",
    view: "View",
    selectAnnouncementType: "Select",
    publisher: "Publisher",
    publishedAt: "Published at",
    selectDepartment: "Select",
    content: "Content",
    enterContent: "Enter content",
    confirm: "Confirm",
    cancel: "Cancel",
    titleRequired: "Title is required",
    typeRequired: "Type is required",
    departmentRequired: "Department is required",
    addAnnouncement: "Add Announcement",
    details: "Details",
    editAnnouncement: "Edit Announcement",
    editSuccess: "Updated successfully",
    addSuccess: "Announcement added successfully",
    formValidationFailed: "Form validation failed:",
    confirmDeleteMessage: 'Are you sure you want to delete announcement(s) "',
    confirmDeleteSuffix: '"?',
    prompt: "Warning",
    deleteSuccess: "Announcement deleted successfully",
    announcementDetails: "Announcement Details",
  },
  workflow: {
    cancel: "Cancel",
    submit: "Submit",
    submitSuccess: "Submission successful",
    formCreateSuccess: "Form created successfully",
    formEditSuccess: "Form edited successfully",
    completeSteps: "Please complete all steps!",
    initiate: "Initiate",
    approvalType: "Workflow Name",
    initiator: "Initiator",
    currentStep: "Current Step",
    submittedAt: "Submitted At",
    endedAt: "Ended At",
    approvalStatus: "Status",
    duration: "Duration",
    inProgress: "In Progress",
    withdrawn: "Withdrawn",
    rejected: "Rejected",
    approved: "Approved",
    flowNotEnded: "Ongoing (has not ended)",
    timeFull: "{0}y {1}mo {2}d {3}h {4}m {5}s",
    timeNoYears: "{0}mo {1}d {2}h {3}m {4}s",
    timeNoMonths: "{0}d {1}h {2}m {3}s",
    timeNoDays: "{0}h {1}m {2}s",
    timeNoHours: "{0}m {1}s",
    timeOnlySeconds: "{0}s",
    processingTime: "Processing Time",
  },
  workorder: {
    ticketTitle: "Ticket Title",
    ticketTitlePlaceholder: "Please enter a ticket title",
    department: "Department",
    departmentPlaceholder: "Select a department",
    user: "Assign to",
    selectUser: "Select a user",
    userPlaceholder: "Select a user from the department",
    priority: "Priority",
    type: "Type",
    ticketType: "Ticket Type",
    ticketDescription: "Ticket Description",
    description: "Description",
    descriptionPlaceholder: "Describe the issue in detail",
    submit: "Submit",
    validateTitle: "Please enter a ticket title",
    validatePriority: "Please select a priority",
    validateType: "Please select a ticket type",
    validateDepartment: "Please select a department",
    createSuccess: "Ticket created successfully",
    select: "Select",
    search: "Search",
    reset: "Reset",
    id: "ID",
    title: "Title",
    status: "Status",
    creator: "Created by",
    selectHandler: "Select assignee",
    currentAssignee: "Assigned to",
    solutionLog: "Solution Log",
    assignee: "Assignee",
    assignedBy: "Assigned by",
    assigneeName: "Assignee Name",
    assignmentTime: "Assignment Time",
    createdAt: "Created at",
    updatedAt: "Updated at",
    ticketDetail: "Ticket Details",
    basicInfo: "Basic Information",
    formInfo: "Form Information",
    actionHistory: "Action History",
    performedBy: "Performed by",
    actionType: "Action Type",
    actionDescription: "Action Description",
    assignmentHistory: "Assignment History",
    timestamp: "Timestamp",
    accept: "Accept",
    assign: "Assign",
    rollback: "Reject",
    complete: "Complete",
    edit: "Edit",
    delete: "Delete",
    reject: "Reject",
    urge: "Remind",
    assignReason: "Assignment Reason",
    assignReasonPlaceholder: "Enter reason for assignment",
    confirm: "Confirm",
    cancel: "Cancel",
    requester: "Requested by",
    requesterPlaceholder: "Select requester",
    statusLabel: "Status",
    confirmAccept: "Are you sure you want to accept this ticket?",
    acceptConfirm: "Confirm Acceptance",
    acceptedSuccess: "Ticket accepted successfully",
    confirmRollback: "Are you sure you want to reject this ticket?",
    rollbackConfirm: "Confirm Rejection",
    rollbackReason: "Rejection Reason",
    rollbackReasonPlaceholder: "Please provide a reason for the rejection",
    rollbackEmpty: "Rejection reason cannot be empty",
    rollbackSuccess: "Ticket rejected successfully",
    resolution: "Resolution",
    resolutionPlaceholder: "Please enter a resolution",
    resolutionEmpty: "Resolution cannot be empty",
    confirmComplete:
      "Are you sure you want to complete this ticket?\nResolution: {resolution}",
    completeConfirm: "Confirm Completion",
    completeSuccess: "Completion successful",
    assignSuccess: "Assigned successfully",
    urgeTooSoon: "Please wait at least one minute before reminding again",
    urgeAcceptPrompt: "Remind the assignee to accept this ticket?",
    urgeCompletePrompt: "Remind the assignee to complete this ticket?",
    warning: "Warning",
    urgeSent: "Reminder sent to assignee",
    inputTitle: "Enter title",
    inputDescription: "Enter description",
    inputType: "Select type",
    inputPriority: "Select priority",
    inputCreatedTime: "Enter creation time",
    inputUpdatedTime: "Enter update time",
    updateSuccess: "Updated successfully",
    confirmBatchDelete: "Are you sure to delete the selected tickets?",
    confirmDelete: "Are you sure you want to delete this ticket?",
    deleteSuccess: "Deleted successfully",
    description1: "Description",
    ticketEdit: "Edit Ticket",
    ticketAssign: "Assign Ticket",
    expenseschart: "Expenses Chart",
  },
  wdrawer: {
    approvalDetails: "Approval Details",
    idLabel: "ID:",
    notSelected: "Not selected",
    star: "Star",
    zeroStar: "0 Star",
    to: "-",
    durationLabel: "Duration:",
    participateComment: "Join Comment",
    inProgress: "In Progress",
    signatureLabel: "Signature:",
    approvalInProgress: "Workflow in progress",
    initiatedByMe: "Initiated by Me",
    revoke: "Withdraw",
    pendingMyAction: "Pending My Action",
    approve: "Approve",
    reject: "Reject",
    ccToMe: "CC'd to Me",
    comment: "Comment",
    processed: "Processed",
    printPreview: "Print Preview",
    approvalId: "Approval ID:",
    submittedAt: "Submitted At:",
    applicant: "Applicant",
    approvalFlow: "Approval Flow",
    approvedAlready: "Approved",
    approvalResult: "Approval Result",
    approvalPassed: "Approved",
    printedBy: "Printed By:",
    printedAt: "Printed At:",
    cancel: "Cancel",
    print: "Print",
    withdrawn: "Withdrawn",
    rejected: "Rejected",
    approved: "Approved",
    noDateTimeRangeComponent: "Date-time range component not found",
    noDateTimeRangeProvided: "No date-time range provided",
    zeroDurationWarning: "0 (Duration is 0, please confirm)",
    year: "Y",
    month: "M",
    day: "D",
    hour: "h",
    minute: "min",
    confirmDownload: "Are you sure you want to download {0}?",
    prompt: "Notice",
    confirm: "Submit",
    downloadSuccess: "File downloaded successfully",
    approver: "Approver",
    clickToSign: "Click to Sign",
    pleaseSignWithMouse: "Please sign with your mouse:",
    clearCanvas: "Clear Signature",
    confirmSignature: "Confirm Signature",
    signaturePreview: "Your Signature Preview:",
    addComment: "Add Comment",
    submitApproval: "Submit for Approval",
    rejectApproval: "Reject Workflow",
    revokeProcess: "Withdraw Workflow",
    commentContent: "Comment content",
    remark: "Remarks",
    rejectionReason: "Reason for rejection",
    revokeReason: "Reason for withdrawal",
    pleaseEnterContent: "Please enter content",
    collectedData: "Collected Data:",
    approvalApproved: "Workflow approved successfully",
    approvalRejected: "Workflow rejected successfully",
    processRevoked: "Workflow withdrawn successfully",
    commentAdded: "Comment added successfully",
    unknownActionType: "Unknown action type",
  },
  upload: {
    selectFile: "Select File",
    addAttachment: "Add Attachment",
    singleAttachmentLimit: "Max size: 10 MB per attachment",
    attachmentTooLarge: "Attachment size cannot exceed 10 MB!",
    fileTooLarge: "File size exceeds the maximum limit (100MB)",
    uploadSuccess: "File uploaded successfully",
    uploadFailed: "File upload failed",
    maxOneAttachment: "Only one attachment can be uploaded",
    addImage: "Add Image",
    perImageLimit: "Max size: 10 MB per image",
    imageOnly: "Only image files are allowed!",
    imageTooLarge: "Image size cannot exceed 10 MB!",
    maxOneImage: "Only one image can be uploaded",
  },
};
